export enum EdmStatus {
    NEW = 'New',
    CONTACTED = 'Contacted',
    ACTIVE = 'Active',
    LISTED = 'Listed',
    SOLD = 'Sold',
    ARCHIVE = 'Archived',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TExpectedDecisionMaker = { [k: string]: any } & {
    edmId: number;
    status: EdmStatus;
    age: number;
    firstName: string;
    lastName: string;
    relationship?: string;
    phones: Array<{
        number: string;
        dnc: boolean;
        index?: number;
        updatedAt?: Date;
    }>;
    emails: Array<{ value: string; index?: number; updatedAt?: Date }>;
    addresses: Array<{
        address: string;
        city: string;
        state: string;
        zip: string;
        index?: number;
        updatedAt?: Date;
    }>;
    dateOfBirth: string;
};
